// App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/hero/Hero';
import SupportFlow from './components/support/SupportFlow';
import ConcernsSection from './components/concerns/ConcernsSection';
import InfoSection from './components/info/InfoSection';
import FAQ from './components/faq/FAQ';
import Blog from './components/blog/Blog';
import PrivacyPolicy from './components/privacy/PrivacyPolicy';
import LineWidget from './components/widgets/LineWidget';
import MobileButtons from './components/widgets/MobileButtons'; 
import Footer from './components/Footer/Footer';
import ReasonsSection from './components/reasons/ReasonsSection';
import './components/contact/Contact.css';
import './components/hero/Hero.css';
import './components/hero/MobileHero.css';
import './components/property/PropertyList.css';
import './components/support/SupportFlow.css';
import './components/support/MobileSupportFlow.css';
import './components/concerns/ConcernsSection.css';
import './components/concerns/MobileConcernsSection.css';
import './components/info/InfoSection.css';
import './components/info/MobileInfoSection.css';
import './components/faq/FAQ.css';
import './components/faq/MobileFAQ.css';
import './components/blog/Blog.css';
import './components/blog/MobileBlog.css';
import './components/widgets/LineWidget.css';
import './components/widgets/MobileButtons.css';
import './components/Footer/Footer.css';
import './components/Footer/Footer-mobile.css';
import './components/reasons/ReasonsSection.css';
import './components/reasons/MobileReasons.css';
import './components/privacy/PrivacyPolicy.css';
import './components/privacy/MobilePrivacyPolicy.css';
import PropertyList from './components/property/PropertyList';

function App() {
  // State to track whether to show the privacy policy
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  
  // Check URL parameters on component mount and when URL changes
  useEffect(() => {
    // Function to check URL parameters
    const checkUrlParams = () => {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      
      if (params.get('page') === 'privacy') {
        setShowPrivacyPolicy(true);
        // Scroll to top when showing privacy policy
        window.scrollTo(0, 0);
      } else {
        setShowPrivacyPolicy(false);
      }
    };
    
    // Check on initial load
    checkUrlParams();
    
    // Add event listener for URL changes
    window.addEventListener('popstate', checkUrlParams);
    
    // Clean up event listener
    return () => {
      window.removeEventListener('popstate', checkUrlParams);
    };
  }, []);

  // Handle URL hash/anchor links for smooth scrolling
  useEffect(() => {
    // Function to handle hash changes
    const handleHashChange = () => {
      // Don't handle hash if privacy page is shown
      if (showPrivacyPolicy) return;
      
      // Get the hash from the URL (without the # symbol)
      const hash = window.location.hash.substring(1);
      
      if (hash) {
        // Give a short delay to ensure the page is fully rendered
        setTimeout(() => {
          const targetElement = document.getElementById(hash);
          if (targetElement) {
            // Calculate header height for offset
            const headerHeight = document.querySelector('.header-nav-container')?.offsetHeight || 0;
            
            // Scroll to element with smooth behavior
            window.scrollTo({
              top: targetElement.offsetTop - headerHeight,
              behavior: 'smooth'
            });
          }
        }, 300);
      }
    };
    
    // Handle hash on initial load
    handleHashChange();
    
    // Add event listener for hash changes
    window.addEventListener('hashchange', handleHashChange);
    
    // Clean up event listener
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [showPrivacyPolicy]);

  // Add style to the main content area for the privacy page
  const contentStyle = showPrivacyPolicy ? 'privacy-page' : '';

  return (
    <div className="app" id="top">
      {/* Header component */}
      <Header />

      <main className={`main-content ${contentStyle}`}>
        {showPrivacyPolicy ? (
          // Show only the Privacy Policy when requested
          <PrivacyPolicy />
        ) : (
          // Otherwise show the regular home page content
          <>
            {/* Hero Section */}
            <Hero />

            {/* Info Section - Add ID for navigation */}
            <section id="infoSection">
              <InfoSection />
            </section>

            {/* Concerns Section */}
            <ConcernsSection />

            {/* Reasons Section - Add ID for navigation */}
            <section id="reasonsSection">
              <ReasonsSection />
            </section>

            {/* Property List Section - Add ID for navigation */}
            <section id="propertyList">
              {/* <PropertyList /> */}
            </section>
            
            {/* Support Flow Section - Add ID for navigation */}
            <section id="supportFlow">
              <SupportFlow />
            </section>
            
            {/* FAQ Section - Add ID for navigation */}
            <section id="faqSection">
              <FAQ />
            </section>
            
            {/* Blog Section - Add ID for navigation */}
            <section id="blogSection">
              <Blog />
            </section>
          </>
        )}
      </main>

      {/* LINE Widget Component (desktop only) */}
      <LineWidget />
      
      {/* Mobile Buttons Component (mobile only) */}
      <MobileButtons />

      {/* Footer Component */}
      <Footer />
    </div>
  );
}

export default App;